import React from 'react';
import { useDispatch } from 'react-redux';
import { Pressable } from '../../web/react-native';
import styled from '../../components/styled';
import { TextInput } from '../../web/react-native';
import MaterialIcon from '../../components/Icon';

import { selectReportTemplates, selectTemplateSelected, shiftLogActions } from '../../store';
import { AppDispatch } from '../../store/store';

const AssetPicker = () => {
  const dispatch = useDispatch<AppDispatch>();

  const templates = selectReportTemplates.useHook();
  const selected = selectTemplateSelected.useHook();

  const hasFetchTemplates = typeof templates !== 'undefined';
  const hasNoTemplates = !hasFetchTemplates || templates?.length === 0;

  const handleAssetSelectorPressed = () => {
    dispatch(shiftLogActions.modalChanged(true));
  };

  return (
    <Container>
      <AssetTitle disabled={false}>Template</AssetTitle>
      <AssetSelectorBox onPress={handleAssetSelectorPressed} disabled={hasNoTemplates}>
        <AssetTextFieldWrapper pointerEvents="none">
          <AssetTextField
            placeholder={
              hasFetchTemplates
                ? hasNoTemplates
                  ? 'No Templates Available'
                  : 'Select Template'
                : 'Loading Templates'
            }
            value={selected?.displayName ?? ''}
          />
        </AssetTextFieldWrapper>
        <Triangle disabled={hasNoTemplates} />
      </AssetSelectorBox>
    </Container>
  );
};

export default AssetPicker;

const AssetTextField = styled(TextInput).attrs({
  placeholderTextColor: '#ccc',
  editable: false,
})`
  height: 40px;
  color: #222;  
`;

const Container = styled.View`
  margin: 10px 20px;
`;

interface DisabledProps {
  disabled: boolean;
}

const AssetTitle = styled.Text<DisabledProps>`
  color: ${(props) => {
    return props.disabled ? '#ccc' : '#222';
  }};
`;

const AssetSelectorBox = styled(Pressable)<DisabledProps>`
  height: 40px;
  border-radius: 4px;
  border-width: 1px;
  border-color: #ccc;
  background-color: ${(props) => {
    return props.disabled ? '#ffffff77' : '#fff';
  }};
  margin-top: 3px;
  margin-bottom: 10px;
  padding-left: 8px;
  flex-direction: row !important;
`;

const Triangle = styled(MaterialIcon).attrs({
  name: 'arrow-drop-down',
})<DisabledProps>`
  font-size: 40px;
  position: absolute;
  right: 5px;
  color: ${(props) => {
    return props.disabled ? '#ccc' : '#777';
  }};
`;

const AssetTextFieldWrapper = styled.View`
  flex: 1;
  height: 100px;  
`;
